import { useField } from "formik";
import React from "react";
import { TextInput, Field, FieldLabel, InlineNotification} from '@blueprint/ui';

import { GenericFieldProps } from "./common";

export type AuthCodeFieldProps = GenericFieldProps & {
    ariaLabelledBy?: string;
    required?: boolean;
};

const AuthCodeField = ({
    className,
    name,
    label,
    autoFocus,
    ariaLabelledBy,
    required,
}: AuthCodeFieldProps): JSX.Element => {
    const [field, meta, helpers] = useField(name);
    const ariaLabel = ariaLabelledBy ? ariaLabelledBy : `notification-help-${name}`;
    return (
        <Field>
            <FieldLabel marginBottom='6px' htmlFor={name}>{label}</FieldLabel>
            <TextInput
                variant="light.large"
                id={name}
                type={'text'}
                {...field}
                style={{marginBottom: '20px'}}
                invalid={Boolean(meta.error)}
                maxLength={6}
                onChange={({value})=>{
                    if (value.toString().indexOf('e') <= -1 && value.toString() === value.toString().replace(/\D/g,''))
                        helpers.setValue(value);
                }}
                aria-label={label}
                aria-labelledby={ariaLabel}
                aria-describedby={`notification-help-${name}`}
                required={required}
            />
            {meta.error && (
                <InlineNotification variant="warning" id={`notification-help-${name}`}>{meta.error}</InlineNotification>
            )}
        </Field>
    );
};

export default AuthCodeField;
